// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".header-title[data-v-63b41cfb]{font-size:1.25rem;-webkit-user-select:none;-moz-user-select:none;user-select:none;vertical-align:middle}.header-title svg[data-v-63b41cfb]{height:.85rem}@media(min-width:992px){.header-title[data-v-63b41cfb]{font-size:1.5rem}.header-title svg[data-v-63b41cfb]{height:1rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
